import React, { useEffect, useState } from "react";
import {
  Container, Typography, Box, Grid, Avatar, Divider, CircularProgress, Button
} from "@mui/material";
import { useParams,useNavigate } from "react-router-dom";
import instance from "../utils/axiosInstance";
import { getMetaFromTokenURI, getIpfsUrl } from "../utils/meta_in_token";
import NFTCard from "../components/NFTCard";

const API_BASE_URL = process.env.REACT_APP_BACK_URL;


const UserProfile = () => {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [ownedNFTs, setOwnedNFTs] = useState([]);
  const [onSaleNFTs, setOnSaleNFTs] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await instance.get(`/user/${userId}`);
        setUser(res.data.user);

        const withMeta = await Promise.all((res.data.ownedNFTs || []).map(async (nft) => {
          const meta = await getMetaFromTokenURI(nft.tokenURI);
          return {
            ...nft,
            name: meta?.name || nft.tokenName,
            description: meta?.description || nft.tokenDescription,
            displayImage: getIpfsUrl(meta?.image || "")
          };
        }));

        const withSaleMeta = await Promise.all((res.data.onSaleNFTs || []).map(async (nft) => {
          const meta = await getMetaFromTokenURI(nft.tokenURI);
          return {
            ...nft,
            name: meta?.name || nft.tokenName,
            description: meta?.description || nft.tokenDescription,
            displayImage: getIpfsUrl(meta?.image || "")
          };
        }));
        

        setOwnedNFTs(withMeta);
        setOnSaleNFTs(withSaleMeta);
      } catch (err) {
        console.error("유저 프로필 조회 실패:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [userId]);

  if (loading) return <Box display="flex" justifyContent="center" mt={8}><CircularProgress /></Box>;
  if (!user) return <Typography align="center" mt={8}>사용자 정보를 찾을 수 없습니다.</Typography>;
  const renderSection = (title, nfts, link) => (
    <Box sx={{ mb: 8 }}>
      <Box 
        display="flex" 
        justifyContent="space-between" 
        alignItems="center" 
        mb={3} 
        sx={{ 
          borderBottom: "1px solid #bbb", 
          pb: 1 
        }}
      >
        <Typography variant="h5" fontWeight="bold">{title}</Typography>
        <Button onClick={() => navigate(link)}>전체보기 →</Button>
      </Box>
      {nfts.length === 0 ? (
        <Typography color="text.secondary" mt={2}>표시할 NFT가 없습니다.</Typography>
      ) : (
        <Grid container spacing={3}>
          {nfts.map((nft) => (
            <Grid item key={nft._id} sx={{ flexBasis: "20%", maxWidth: "20%" }}>
              <NFTCard item={nft} onClick={() => navigate(`/nft/${nft._id}`)} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
  return (
    <Container sx={{ mt: 6 }}>
      <Box display="flex" alignItems="center" gap={3} mb={4}>
      <Avatar src={user.profileImage ? `${API_BASE_URL}${user.profileImage}` : undefined} />

        <Box>
          <Typography variant="h5" fontWeight="bold">{user.name}</Typography>
          <Typography variant="body2" color="text.secondary">{user.email}</Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 4 }} />

      {renderSection(
        "보유 중인 NFT", 
        ownedNFTs, 
        `/nftlist/1?keyword=${encodeURIComponent(user._id)}&field=owner`
      )}

      {renderSection(
        "판매 중인 NFT", 
        onSaleNFTs, 
        `/nftlist/1?keyword=${encodeURIComponent(user._id)}&field=owner&isSale=true`
      )}
    </Container>
  );
};

export default UserProfile;
